import { useAuth0 } from "@auth0/auth0-react";
import { Icon, InlineIcon } from "@iconify/react";
import _ from "lodash";
import { useContext } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AuthEnvContext, AuthEnvContextHoc, brand, custom_auth } from "../../../../context";
import { useApoAuth } from "../../../../hooks";
import jssVariables from "../../../../jss_setup";
import { AuthHoc } from "../../../../umbilical_hocs";
import { TranslationContext } from "../../../../umbilical_tools";

export const itemStyles = {
  display: "none",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "small",
  background: "none",
  color: jssVariables.colors.text.dark,
  textTransform: "capitalize",
  transition: "border-color .3s",
  "&:hover": {
    textDecoration: "none!important",
    "&:disabled": { cursor: "default" },
  },
  smallscreen: { fontSize: "large" },
  bigscreen: { fontSize: "large" },
};

const itemIconStyles = {
  color: jssVariables.colors.base_color,
};

const loginCompStyles = createUseStyles({
  item: (props) => ({
    ...itemStyles,
    ..._.get(props, "customStyles.item", {}),
    position: "relative",
  }),
  itemIcon: {
    ...itemIconStyles,
  },
  avatar: (props) => ({
    width: jssVariables.double_gap,
    aspectRatio: "1/1",
    borderRadius: "50%",
    objectFit: "contain",
    ..._.get(props, "customStyles.avatar", {}),
  }),
  profileItem: (props) => ({
    ..._.get(props, "customStyles.profileItem", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    item: (props) => ({
      ...itemStyles.smallscreen,
      display: "grid",
      gridAutoFlow: "column",
      alignItems: "center",
      gridGap: jssVariables.half_gap,
      ..._.get(props, "customStyles.item.smallscreen", {}),
    }),
    profileItem: (props) => ({
      ..._.get(props, "customStyles.profileItem.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    item: (props) => ({
      ...itemStyles.bigscreen,
      ..._.get(props, "customStyles.item.bigscreen", {}),
    }),
  },
});

var LoginComp = ({ customStyles }) => {
  const { t } = useContext(TranslationContext);

  const classes = loginCompStyles({
    customStyles,
  });

  const { isAuthenticated } = useApoAuth();
  const { user, loginWithRedirect } = useAuth0();
  const history = useHistory();
  const authCtx = useContext(AuthEnvContext);

  const user_picture = _.get(user, "picture");

  const unreadEventsByUsername = useSelector(
    (state: { ChatReducer: { unreadEventsByUsername: Set<string> } }) =>
      state.ChatReducer?.unreadEventsByUsername || new Set<string>(),
  );

  const unreadCount = unreadEventsByUsername.size;

  return (
    <div
      className={`${classes.item} ${classes.profileItem} pr-3`}
      onClick={async () => {
        if (!isAuthenticated && !custom_auth) {
          await loginWithRedirect({ redirect_uri: authCtx.redirectUrl });
        } else {
          history.push("/my_profile");
        }
      }}
    >
      {user && user_picture ? (
        <img src={user_picture} alt="user avatar" className={classes.avatar} />
      ) : (
        <InlineIcon icon="user-circle-o" className={classes.itemIcon} />
      )}{" "}
      {isAuthenticated ? (
        brand === "travily" ? (
          t("myAccount")
        ) : (
          t("myProfile")
        )
      ) : custom_auth ? (
        <Icon icon="mingcute:loading-line" className="Loader__icon" />
      ) : (
        t("login")
      )}
      {isAuthenticated && unreadCount > 0 && (
        <span className="absolute -right-3 bg-red-500 text-white rounded-full min-w-[18px] h-[18px] flex items-center justify-center text-[11px] font-bold px-1 leading-none shadow-md">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </div>
  );
};

LoginComp = AuthEnvContextHoc(AuthHoc(LoginComp));
export { LoginComp };
